import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import { loadRuntimeConfig } from './api/client'
import './styles/main.css'

loadRuntimeConfig().finally(() => {
  createApp(App).use(createPinia()).use(router).mount('#app')
})
